import { render } from 'preact';
import { AdminApp } from './AdminApp';
import './admin.css';

const root = document.getElementById('admin-root');
if (root) {
  render(<AdminApp />, root);
}
